import {BatteryReplacement} from '../my-features/battery-replacement/battery-replacement.model';
import {ɵStyleData} from '@angular/animations';

export interface UserDevicesInfo {
  Id: number;
  AccountId: number;
  DeviceType: number;
  DeviceName: string;
  Model: string;
  DeviceSN: string;
  DeviceOS: string;
  OSVersion: string;
  Region: string;
  Unique_ID: string;
  Device_ID: string;
  CreateUser: string;
  CreateTime: Date;
  UpdateUser: string;
  UpdateTime: Date;
  IsActive: boolean;
  FirmwareVersion: string;
  Description: string;
  DeviceCode: number;
  is_shared: boolean;
  RegionId?: number;
  DeviceSubType: number;
  SourceType: number;
  DisplaySourceType: number;
  DeviceIP: string;
}

export interface DevicesStatus extends UserDevicesInfo {
  device_sn: string;
  device_status?: number;
  BatCap?: number;
  BatRun?: number;
  BatSta?: number;
  BHI?: number;
  Load?: number;
  LoadPctA?: number;
  LoadPctB?: number;
  LoadPctC?: number;
  event?: string;
  dcode: number;
  expiredDate?: Date;
  level: number;
  desc?: string;
  co2Emitted?: number;
  energyCost?: number;
  countrySelection?: string;
  unit?: number;
  connectedDate?: Date;
  timeZone: number;
  gId?: number;
  levelChangedCnt?: number;
  isExpired: boolean;
  acode?: number;
  hardwarefault_event: {
    levelcode?: string;
    errorcodes?: any[];
  };
  canTrial: boolean;
  trial_remainday: number;
  plan_activate: boolean;
  Protecting: boolean;
  msp_plan_activate?: boolean;
  RegionId?: number;
  Cur?: number;
  Volt?: number;
  VoltA?: number;
  VoltB?: number;
  VoltC?: number;
  InVoltA?: number;
  InVoltB?: number;
  InVoltC?: number;
  OutVolt?: number;
  Energy?: number;
  EnergyT?: number;
  Power?: number;
  PowerT?: number;
  Brand?: string;
  BHI_Enable?: boolean;
}

export interface ShareDevicesStatus extends DevicesStatus {
  owner_acode: number;
  share_status: number;
  share_id: number;
  share_group_id: number;
}

export interface DevicesStatusPack {
  DeviceList: DevicesStatus[];
  ShareDeviceList: ShareDevicesStatus[];
  ShareGroupDeviceList: ShareDevicesStatus[];
}

export interface DeviceDetails {
  Model: string;
  SN?: string;
  PowSour?: number;
  OutVolt?: number;
  OutSta: any; // Power Condition
  InSta?: any; // When only connected with card
  InStaA?: number;
  InStaB?: number;
  Energy?: number;
  BatCap?: number;
  BatSta?: any;
  BatRun?: number;
  Load?: number;
  LoadPct?: number;
  LoadPctA?: number;
  LoadPctB?: number;
  LoadPctC?: number;
  FV?: string;
  RatPow?: number;
  statistic?: any[];
  countrySelection?: string;
  energyCost?: number;
  co2Emitted?: number;
  unit?: number;
  SysTemp?: number;
  RemainDay?: number;
  TrialRemainDay?: number;
  expirationDate?: number;
  LP?: number;
  BHI?: number;
  BHI_Enable?: boolean;
  is_critical_update?: boolean;
  acode?: number;
  dcode?: number;
  device_status?: number;
  device_type?: number;
  DeviceName?: string;
  DeviceSubType?: number;
  SourceType?: number;
  hardwarefault_event?: any;
  event?: string;
  timeZone?: number;
  device_setting?: DeviceSetting;
  timestamp?: string;
  Source?: number;
  Power?: number;
  BpsVoltA?: number;
  BpsVoltB?: number;
  BpsVoltC?: number;
  InPFA?: number;
  InPFB?: number;
  InPFC?: number;
  InVoltA?: number;
  InVoltB?: number;
  InVoltC?: number;
  OutPwA?: number;
  OutPwB?: number;
  OutPwC?: number;
  OutPFA?: number;
  OutPFB?: number;
  OutPFC?: number;
  OutVoltA?: number;
  OutVoltB?: number;
  OutVoltC?: number;
  BatVolt?: number;
  BatRDate?: string;
  GeoRegion?: number;
  GeoType?: number;
  ServerNum?: number;
  Cur?: number;
  CurA?: number;
  CurB?: number;
  CurC?: number;
  PowerT?: number;
  EnergyT?: number;
  PkCur?: number;
  PkCurA?: number;
  PkCurB?: number;
  PkCurC?: number;
  PkTs?: number;
  Volt?: number;
  VoltA?: number;
  VoltB?: number;
  VoltC?: number;
  Cur1?: number;
  Cur1A?: number;
  Cur1B?: number;
  Cur1C?: number;
  PkCur1?: number;
  PkCur1A?: number;
  PkCur1B?: number;
  PkCur1C?: number;
  PkTs1?: number;
  Volt1A?: number;
  Volt1B?: number;
  Volt1C?: number;
  Energy1?: number;
  Model1?: string;
  SN1?: string;
  Cur2?: number;
  Cur2A?: number;
  Cur2B?: number;
  Cur2C?: number;
  PkCur2?: number;
  PkCur2A?: number;
  PkCur2B?: number;
  PkCur2C?: number;
  PkTs2?: number;
  Volt2A?: number;
  Volt2B?: number;
  Volt2C?: number;
  Energy2?: number;
  Model2?: string;
  SN2?: string;
  Cur3?: number;
  Cur3A?: number;
  Cur3B?: number;
  Cur3C?: number;
  PkCur3?: number;
  PkCur3A?: number;
  PkCur3B?: number;
  PkCur3C?: number;
  PkTs3?: number;
  Volt3A?: number;
  Volt3B?: number;
  Volt3C?: number;
  Energy3?: number;
  Model3?: string;
  SN3?: string;
  SelSrc?: number;
  PreSrc?: number;
  SrcVoltA?: number;
  SrcVoltB?: number;
  SrcFreqA?: number;
  SrcFreqB?: number;
  SrcStaA?: number;
  SrcStaB?: number;
  SelSrc1?: number;
  PreSrc1?: number;
  SrcVolt1A?: number;
  SrcVolt1B?: number;
  SrcFreq1A?: number;
  SrcFreq1B?: number;
  SrcSta1A?: number;
  SrcSta1B?: number;
  SelSrc2?: number;
  PreSrc2?: number;
  SrcVolt2A?: number;
  SrcVolt2B?: number;
  SrcFreq2A?: number;
  SrcFreq2B?: number;
  SrcSta2A?: number;
  SrcSta2B?: number;
  SelSrc3?: number;
  PreSrc3?: number;
  SrcVolt3A?: number;
  SrcVolt3B?: number;
  SrcFreq3A?: number;
  SrcFreq3B?: number;
  SrcSta3A?: number;
  SrcSta3B?: number;
  DeviceIP?: string;
  BpsCurA?: number;
  BpsCurB?: number;
  BpsCurC?: number;
  BpsFreqA?: number;
  BpsFreqB?: number;
  BpsFreqC?: number;
  BpsPFA?: number;
  BpsPFB?: number;
  BpsPFC?: number;
  InCurA?: number;
  InCurB?: number;
  InCurC?: number;
  InFreqA?: number;
  InFreqB?: number;
  InFreqC?: number;
  OutCurA?: number;
  OutCurB?: number;
  OutCurC?: number;
  OutFreqA?: number;
  OutFreqB?: number;
  OutFreqC?: number;
  OutAppA?: number;
  OutAppB?: number;
  OutAppC?: number;
  OutRctA?: number;
  OutRctB?: number;
  OutRctC?: number;
  BatVoltB?: number;
  BatCurA?: number;
  BatCurB?: number;
  BatTemp?: number;
  BatNum?: number;
  ModNum?: number;
  OutStaArr?: number[];
  InStaArr?: number[];
  BatStaArr?: number[];
  OutStaNUM?: number;
  CloudFlag?: number;
}

export interface DevicesInfoData {
  otp?: string;
  dcode: number;
  timeZone?: number;
  desc?: string;
  countrySelection?: string;
  energyCost?: number;
  co2Emitted?: number;
  unit?: number;
  // account?: string;
  deviceName?: string;
  BtyReplaceDate?: number;
  BRD_From?: number;
  BR_Months?: number;
  isBtyReplaced?: boolean;
  BHI_Enable?: boolean;
}

export interface ViewDeviceInfo {
  name: string;
  type: string;
  subtype: string;
  displaysubtype: string;
  displayTag: string;
  DeviceSubType: number;
  SourceType: number;
  DisplaySourceType: number;
  image: string;
  status: string;
  icon: string;
  desc: string;
  batteryStatus: string;
  batteryCapacity?: number;
  batteryRun?: number;
  BHI?: number;
  BHIStatus?: string;
  hideBHI?: boolean;
  Load?: number;
  LoadPctA?: number;
  LoadPctB?: number;
  LoadPctC?: number;
  DeviceSN: string;
  DeviceStatus: string;
  deviceStatusCode: number;
  SelectedType: number;
  region: string;
  deviceDescription: string;
  gId: number;
  dcode: number;
  expireDate: Date;
  level: number;
  co2Emitted: number;
  energyCost: number;
  countrySelection: string;
  unit: number;
  connectedDate: Date;
  timeZone: number;
  levelChangedCnt: number;
  routeLink: string;
  isExpired: boolean;
  hardwarefault: any;
  btyReplacement: BatteryReplacement;
  canTrial: boolean;
  trialRemainDay: number;
  planActivate: boolean;
  owner_acode?: number;
  share_status?: number;
  share_id?: number;
  share_group_id?: number;
  is_shared: boolean;
  share_type: number;
  FirstName?: string;
  LastName?: string;
  SharedFirstName?: string;
  SharedLastName?: string;
  protecting?: boolean;
  mspPlanActivate: boolean;
  regionId: number;
  EditDevice?: number;
  ViewDevice?: number;
  Cur?: number;
  Volt?: number;
  VoltA?: number;
  VoltB?: number;
  VoltC?: number;
  InVoltA?: number;
  InVoltB?: number;
  InVoltC?: number;
  OutVolt?: number;
  Energy?: number;
  EnergyT?: number;
  Power?: number;
  PowerT?: number;
  Brand?: string;
  DeviceIP?: string;
  BHI_Enable?: boolean;
  Model?: string;
}

export interface MiniCardParams {
  otp?: string;
  mac: string;
  key?: string;
  RegionId?: number;
}
export interface MiniCardWithoutPackParams {
  otp: string;
  rSN: string;
  name: string;
  rType?: number;
}
export interface EmbCardParams {
  otp?: string;
  mac: string;
  key?: string;
  RegionId?: number;
}

export interface AddUpdateDeviceParams {
  LoginType?: number;
  OtpKey?: string;
  DeviceType?: number;
  DeviceName?: string;
  Model?: string;
  DeviceSn?: string;
  FirmwareVersion?: string;
  rSN?: string;
  rType?: number;
  RegionId?: number;
  DeviceSubtype?: number;
}

export interface DeviceMonitoringFilter {
  otp?: string;
  acode?: number;
  regionId?: number;
  device_status?: any;
  // device_status?: number;
  // multiDevice_status?: any;
  dcode?: number;
  DeviceSubType?: any;
}

export interface DeviceMonitoringData {
  acode: number;
  dcode: number;
  device_sn: string;
  device_status: number;
  // multiDevice_status?: any;
  device_type: number;
  event: string;
  expiredDate: Date;
  isExpired: boolean;
  level: number;
  regionId: number;
  timeZone: number;
  image?: string;
  hardwarefault_event?: any;
  BHI?: number;
  DeviceSubType: number;
  DisplaySourceType: number;
  SourceType: number;
  Brand?: string;
}

export interface MiniCardInfo {
  result_code: number;
  lastest_log: any;
  haveUPS: boolean;
}
export interface EmbCardInfo {
  result_code: number;
  lastest_log: any;
  haveUPS: boolean;
}

export interface WifiCardInfo {
  model: string;
  mac: string;
  sn: string;
  RG: any;
  rMN: string;
  rFV: string;
  rHV: string;
  rSN: string;
  firmware_version: string;
}

export interface WifiList {
  ssid: string;
  password: boolean;
}

export interface ConnectWifiParams {
  ssid: string;
  password?: string;
  security?: string;
  encryption?: string;
}
export interface DeviceSetting {
  Outlet1: string;
  Outlet2: string;
  Outlet3: string;
  Outlet4: string;
  Outlet5: string;
  Outlet6: string;
  Outlet7: string;
  Outlet8: string;
  Outlet9: string;
  Outlet10: string;
  Outlet11: string;
  Outlet12: string;
  Outlet13: string;
  Outlet14: string;
  Outlet15: string;
  Outlet16: string;
}
